<div class="modal-body flight-trip-in-body">
    <div class="row loading-flight-details" *ngIf="bookingProcessStart">
        <img src="/assets/image/circle-loading.gif" alt="">
        <h4 *ngIf="!isBookingError">{{"Booking process in progress..." | translate}} </h4>
        <p *ngIf="isBookingError"> {{bookingResponse | json}} </p>
    </div>
</div>

<app-thank-you-modal *ngIf="isBookingCompleted"></app-thank-you-modal>